import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { SelectModule } from '~ai-tutor/components/chat/SelectModule';
import { conversationSettingsQueryOptions } from '~ai-tutor/lib/serverFunctions/settings/getConversationSettings';

const chatSearchSchema = z.object({
  messages: z.string().optional(),
});

export const Route = createFileRoute('/_authed/chat')({
  validateSearch: chatSearchSchema,
  loader: async ({ context }) => {
    if (!context.user?.conversationId) {
      throw redirect({
        to: '/settings',
      });
    }

    const settings = await context.queryClient.fetchQuery(
      conversationSettingsQueryOptions(context.user.conversationId),
    );

    // Redirect to settings if user hasn't completed their profile
    if (!settings.jobRole || !settings.experience || !settings.goal) {
      throw redirect({
        to: '/settings',
      });
    }
  },
  component: SelectModule,
});
